import * as actions from '../../actions';
import jwtDecode from './jwtDecode';
import { Store } from '~store';

export const isAuthToken = (authToken: string | null): boolean => {
  if (!authToken) {
    return false;
  }
  const parsedToken = jwtDecode(authToken);

  if (authToken && parsedToken && parsedToken.exp && parsedToken.exp > Date.now() / 1000) {
    return true;
  }

  return false;
};

const TOKEN_KEY = `TOKEN-${process.env.PROJECT_ID}-OM-v2`;

class AuthService {
  store: Store;

  constructor(store: Store) {
    this.store = store;
    this.subscribeToStoreChanges();
  }

  subscribeToStoreChanges() {
    this.store.subscribe(() => {
      const state = this.store.getState();
      this.setLocalAuthToken(state);
    });
  }

  setLocalAuthToken = (state: any) => {
    const newAuthToken = state.authToken;
    const currentAuthToken = localStorage.getItem(TOKEN_KEY);
    if (newAuthToken !== currentAuthToken) {
      if (!newAuthToken) {
        localStorage.removeItem(TOKEN_KEY);
      } else {
        localStorage.setItem(TOKEN_KEY, newAuthToken);
      }
    }
  };

  logout() {
    this.store.dispatch(actions.setToken(null));
  }

  checkUserValid(user: any) {
    if (!user) {
      this.logout();
    }
  }
}

export default AuthService;
